module.exports = __webpack_public_path__ + "img/5-4.b35d7501.png";